import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestContactList = ({ pageNumber }) => {
  let getUrl = '/user/contact';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSaveContact = ({ csrfToken, postParams, id }) => {
  const args = { ...postParams };
  if (id) {
    args.id = id;
  }
  const result = apiClient.post(
    '/user/contact/save',
    { csrfToken, postParams: args },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestContactList,
  requestSaveContact,
};
